module.exports = __webpack_public_path__ + "static/media/42.0c8bd5ff.jpg";